export const createCustomTemplateFormMessages = {
  // Section headings
  storyAboutHeading: "What's the story about?",
  illustrationStyleHeading: 'What style are the illustrations?',
  rolesHeading: "Who's in it?",

  // Form field labels
  titleLabel: 'Story Title',
  titlePlaceholder: 'Enter a title for your story',
  descriptionLabel: 'Description (Optional)',
  descriptionHelpText:
    'For best results, enter a short, clear description of the plot or theme of your story.',
  descriptionPlaceholder:
    "e.g. 'A little girl gets to be police chief for a day' or 'Grandma and David have a special day at the beach in Santa Monica'",
  styleTemplateLabel: 'Style Template',
  styleTemplateDescription: 'Choose a visual style for your story',
  styleTemplatePlaceholder: 'Select a style template',
  rolesDescriptionLine1:
    'Choose the characters needed for your story (at least one required).',
  rolesDescriptionLine2:
    'You will fill in their name and picture in the next step.',

  // Role template fields
  roleTemplateLabel: 'Character',
  roleTemplatePlaceholder: 'Select a role template',

  // Buttons
  addRoleButton: 'Add Role',
  removeRoleButton: 'Remove Role',
  createTemplateButton: 'Create Story',
  cancelButton: 'Cancel',

  // Validation messages
  titleRequired: 'Title is required',
  atLeastOneRole: 'At least one role is required',
  styleTemplateRequired: 'Style template is required',

  // Status messages
  creating: 'Creating template...',

  // Loading states
  loadingRoleTemplates: 'Loading role templates...',
  loadingStyleTemplates: 'Loading style templates...',

  // Accessibility
  addRoleAriaLabel: 'Add a new role to the story template',
  removeRoleAriaLabel: 'Remove this role from the story template',
  formAriaLabel: 'Custom story template creation form',
} as const;
